var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLayer2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.263,
    height: 31.648,
    viewBox: "0 0 45.263 31.648",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3897",
    "data-name": "Path 3897",
    d: "M23.382.006A31.438,31.438,0,0,1,44.22,8.335l.394.363a2.09,2.09,0,0,1,0,3.029,2.12,2.12,0,0,1-3.029,0,46.006,46.006,0,0,0-5.24-4,27.773,27.773,0,0,0-32.5,3.665,3.544,3.544,0,0,1-1.393.727,1.817,1.817,0,0,1-2.181-.909A1.908,1.908,0,0,1,.728,8.728,57.758,57.758,0,0,1,6.058,4.64,31.953,31.953,0,0,1,23.382.006Z",
    transform: "translate(0 0.003)",
    fill: "#f7921f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3898",
    "data-name": "Path 3898",
    d: "M18.277,3.07A22.352,22.352,0,0,1,34,9.37a2.15,2.15,0,0,1,.606,2.665,1.848,1.848,0,0,1-2.12,1.03,3.271,3.271,0,0,1-1.3-.727,18.172,18.172,0,0,0-25.562,0,2.12,2.12,0,0,1-3.029,0A2.15,2.15,0,0,1,2.922,9.31,22.14,22.14,0,0,1,18.277,3.07Z",
    transform: "translate(4.288 6.236)",
    fill: "#f7921f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3899",
    "data-name": "Path 3899",
    d: "M24.951,11.77a7.935,7.935,0,0,1-1.514,1.635,1.726,1.726,0,0,1-2.272-.424,9.571,9.571,0,0,0-5-2.574,9.45,9.45,0,0,0-8.48,2.544,2,2,0,0,1-2.484.424,1.817,1.817,0,0,1-1.03-2.09,2.484,2.484,0,0,1,.666-1.242,13.69,13.69,0,0,1,19.141,0A8.42,8.42,0,0,1,24.951,11.77Z",
    transform: "translate(8.365 12.468)",
    fill: "#f7921f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3900",
    "data-name": "Path 3900",
    d: "M11.759,11.305a2.574,2.574,0,0,1-5.119-.151,2.574,2.574,0,0,1,5.119.151Z",
    transform: "translate(13.472 18.112)",
    fill: "#f7921f"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer2);
export default __webpack_public_path__ + "static/media/Layer2.d54b5e47da8bb77f97085dc7f4a8b003.svg";
export { ForwardRef as ReactComponent };